import { useState } from "react";
import { Briefcase, Share2, MessageCircle, Mail, Phone, Check } from "lucide-react";
import { toast } from "sonner";
import { waLink } from "@/lib/data";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function HireShare({ member }) {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  if (!member) return null;

  const shareUrl = `${window.location.origin}/verify/${member.membership_id}`;
  const wa = waLink(member.phone);

  const share = async () => {
    const data = { title: `${member.full_name} · Nasarawa Expo`, text: `Hire ${member.full_name}, ${member.expertise} from ${member.lga} LGA`, url: shareUrl };
    if (navigator.share) {
      try { await navigator.share(data); return; } catch { /* fall through */ }
    }
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toast.success("Profile link copied");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = shareUrl; ta.style.position = "fixed"; ta.style.opacity = "0";
      document.body.appendChild(ta); ta.focus(); ta.select();
      try { document.execCommand("copy"); setCopied(true); toast.success("Profile link copied"); setTimeout(() => setCopied(false), 2000); }
      catch { toast.message("Copy this link", { description: shareUrl }); }
      document.body.removeChild(ta);
    }
  };

  return (
    <div className="flex items-center justify-center gap-3">
      <Button onClick={() => setOpen(true)} className="bg-[#E6197E] hover:bg-[#C4136B] rounded-full px-6 font-semibold" data-testid="hire-me-button">
        <Briefcase className="w-4 h-4 mr-2" /> Hire Me
      </Button>
      <Button onClick={share} variant="outline" className="border-white/15 bg-transparent rounded-full px-6" data-testid="share-profile-button">
        {copied ? <Check className="w-4 h-4 mr-2 text-emerald-400" /> : <Share2 className="w-4 h-4 mr-2" />} Share
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#131519] border-white/10 max-w-sm">
          <DialogHeader><DialogTitle className="font-heading">Contact {member.full_name}</DialogTitle></DialogHeader>
          <p className="text-sm text-zinc-400 -mt-2">Reach out to discuss a booking or project.</p>
          <div className="space-y-2.5 mt-2">
            {wa && (
              <a href={wa} target="_blank" rel="noreferrer" data-testid="contact-whatsapp">
                <Button className="w-full bg-emerald-600 hover:bg-emerald-700 rounded-lg justify-start"><MessageCircle className="w-4 h-4 mr-2" /> Chat on WhatsApp</Button>
              </a>
            )}
            {member.phone && (
              <a href={`tel:${member.phone}`} data-testid="contact-call">
                <Button variant="outline" className="w-full border-white/15 bg-transparent rounded-lg justify-start"><Phone className="w-4 h-4 mr-2" /> Call {member.phone}</Button>
              </a>
            )}
            {member.email && (
              <a href={`mailto:${member.email}?subject=Hiring enquiry via Nasarawa Expo`} data-testid="contact-email">
                <Button variant="outline" className="w-full border-white/15 bg-transparent rounded-lg justify-start"><Mail className="w-4 h-4 mr-2" /> Email {member.email}</Button>
              </a>
            )}
            {!wa && !member.phone && !member.email && <p className="text-sm text-zinc-500">No public contact details provided by this member.</p>}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
